import { render, staticRenderFns } from "./medlinkerManager.vue?vue&type=template&id=19150945&scoped=true"
import script from "./medlinkerManager.vue?vue&type=script&lang=js"
export * from "./medlinkerManager.vue?vue&type=script&lang=js"
import style0 from "./medlinker.less?vue&type=style&index=0&id=19150945&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19150945",
  null
  
)

export default component.exports